(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/Enums/XPEnums',["require", "exports"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var XPModuleState;
    (function (XPModuleState) {
        XPModuleState["Pending"] = "pending";
        XPModuleState["InProcess"] = "inprocess";
        XPModuleState["Loaded"] = "loaded";
        XPModuleState["Failed"] = "failed";
    })(XPModuleState = exports.XPModuleState || (exports.XPModuleState = {}));
    ;
    var XPJunction;
    (function (XPJunction) {
        XPJunction["AND"] = "and";
        XPJunction["OR"] = "or";
    })(XPJunction = exports.XPJunction || (exports.XPJunction = {}));
    ;
});
//# sourceMappingURL=XPEnums.js.map;
